module.exports = __webpack_public_path__ + "assets/images/project/cover/cover-desktop.png?v=d6f7d042";